import React from "react";
import "./SponsersPage.scss";

function SponsersPage() {
  return (
    <div>
      <h1 className="SPONSERS-HEADING">Our Sponsers</h1>
      <div className="logo-slider">
        <div>
          <img src="assets/SponsorImages/Aone.jpg" />
          <img src="assets/SponsorImages/espi.jpg" />
          <img src="assets/SponsorImages/eva.jpg" />
          <img src="assets/SponsorImages/gate.jpg" />
          <img src="assets/SponsorImages/happyfaces.jpg" />
          <img src="assets/SponsorImages/icici.jpg" />
          
          <img src="assets/SponsorImages/Aone.jpg" />
          <img src="assets/SponsorImages/espi.jpg" />
          <img src="assets/SponsorImages/eva.jpg" />
          <img src="assets/SponsorImages/gate.jpg" />
          <img src="assets/SponsorImages/happyfaces.jpg" />
          <img src="assets/SponsorImages/icici.jpg" />
          
          <img src="assets/SponsorImages/Aone.jpg" />
          <img src="assets/SponsorImages/espi.jpg" />
          <img src="assets/SponsorImages/eva.jpg" />
          <img src="assets/SponsorImages/gate.jpg" />
          <img src="assets/SponsorImages/happyfaces.jpg" />
          <img src="assets/SponsorImages/icici.jpg" />
        </div>
      </div>
      <div className="logo-slider">
        <div>
          <img src="assets/SponsorImages/ims.jpg" />
          <img src="assets/SponsorImages/kanan.jpg" />
          <img src="assets/SponsorImages/microhub.jpg" />
          <img src="assets/SponsorImages/red.jpg" />
          <img src="assets/SponsorImages/retro.jpg" />
          <img src="assets/SponsorImages/spark.jpg" />
        </div>
      </div>
    </div>
  );
}

export default SponsersPage;
